// Module-level context for passing message metadata into the TokenPill render pipeline
// Set by message components before rendering text, read by TokenPill

export interface TokenPillMessageContext {
  senderId?: string;
  senderName?: string;
  chatId?: string;
  chatTitle?: string;
  messageDate?: number;
  messageId?: number;
}

let currentContext: TokenPillMessageContext | undefined;

export function setTokenPillContext(context: TokenPillMessageContext | undefined) {
  currentContext = context;
}

export function getTokenPillContext(): TokenPillMessageContext | undefined {
  return currentContext;
}
